import NavigationProvider from './NavigationProvider';

export default NavigationProvider;
